import { Button, Form, FormInstance, Input, Select, Space, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  addMemberToBranch,
  fetchAllBranches,
  fetchUserPermissions,
} from "../../../../apis/branch.api";
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";
const { Option } = Select;

export interface BranchMemberCreateProps {
  branch_id?: number;
  onMemberAddDrawerClose: () => void;
}

const SubmitButton = ({ form }: { form: FormInstance }) => {
  const [submittable, setSubmittable] = React.useState(false);
  const values = Form.useWatch([], form);

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => setSubmittable(true),
      () => setSubmittable(false)
    );
  }, [form, values]);

  return (
    <Button type="primary" htmlType="submit" disabled={!submittable}>
      Submit
    </Button>
  );
};

const BranchMemberCreateForm = ({
  onMemberAddDrawerClose,
}: BranchMemberCreateProps) => {
  const [form] = Form.useForm();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("branch_details.create");
  const [permissions, setPermissions] = useState([]);
  const [branches, setBranches] = useState<any[]>([]);

  useEffect(() => {
    fetchUserPermissions().then((result: any) => {
      setPermissions(result);
    });
    fetchAllBranches().then((result: any) => {
      setBranches(result);
    });
  }, []);

  const onFinish = async (updatedValues: any) => {
    if (!canEdit) {
      message.error("You don't have permission to add a member");
      return;
    }
    const ok = await addMemberToBranch(updatedValues, updatedValues?.branch);
    if (ok) {
      onMemberAddDrawerClose();
    }
  };

  return (
    <Form
      form={form}
      name="validateOnly"
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish}
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="branch"
        label="Branch"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          placeholder="Select branch"
          options={branches?.map((branch) => ({
            label: branch?.branch_name,
            value: branch?.id,
          }))}
        />
      </Form.Item>
      <Form.Item
        name="email"
        label="Email"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="contact"
        label="Phone"
        rules={[
          {
            required: true,
            pattern: /^[1-9]\d{9}$/gi,
            message: "Enter a valid phone number",
          },
        ]}
      >
        <Input type="number" maxLength={10} />
      </Form.Item>
      <Form.Item name="department" label="Department">
        <Input />
      </Form.Item>
      <Form.Item
        label="Permission"
        name={"user_permission"}
        rules={[
          {
            required: true,
            message: "Enter a valid user permission",
          },
        ]}
      >
        <Select placeholder="Select permission">
          {permissions?.map((each: any, index) => {
            let displayName = each?.permission_name;
            if (displayName === "customer_success") {
              displayName = "consultants";
            } else if (displayName === "retail") {
              displayName = "receptionist";
            }
            return (
              <Option key={index} value={each?.id}>
                {displayName}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item>
        <Space>
          <SubmitButton form={form} />
          <Button htmlType="reset">Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default BranchMemberCreateForm;
